module.exports = __webpack_public_path__ + "img/form-designtech-logo.ad68dcde.svg";